export class UserData {
    id: number | null = null;
    username: string | null = null;
    saved_data: any | null = null;
}